import React from "react"
import { Button, Table } from "react-bootstrap"
import _ from "lodash"

import FormikBootstrap from "@/components/formik-bootstrap"
import * as TieredRatesheet from "@/pricing/models/TieredRatesheet"

const TieredRatesheetTable = ({
  ratesheet,
  onShiftCategoryLeft,
  onShiftCategoryRight,
  onRemoveTier,
  onRemoveCategory,
  name,
  readOnly,
  canEditPricingStructure,
}) => {
  const table = TieredRatesheet.asTable(ratesheet)

  const rateHeadings = _.drop(table.headings)

  const isFirstCol = (idx) => idx === 0
  const isLastCol = (idx) => idx === rateHeadings.length - 1
  const hasManyRates = rateHeadings.length > 1

  const hasCategoryShifts =
    hasManyRates && canEditPricingStructure && !ratesheet.independentCategories

  // TODO get rid of displayScale below! (makes cents into currency)
  return (
    <Table className="mb-2 table-compact" size="sm">
      <thead>
        <tr>
          <th key="tier-start" className="compact">
            Tier start
          </th>
          {_.map(rateHeadings, (h, idx) => (
            <th key={idx} className="compact">
              {hasCategoryShifts && !isFirstCol(idx) && (
                <Button
                  variant="link"
                  size="sm"
                  onClick={() => onShiftCategoryLeft(h.value)}
                  className="me-1 p-0"
                >
                  <i className="fas fa-angle-left px-1" />
                </Button>
              )}
              <span>{h.label}</span>
              {hasCategoryShifts && !isLastCol(idx) && (
                <Button
                  variant="link"
                  size="sm"
                  onClick={() => onShiftCategoryRight(h.value)}
                  className="ms-1 p-0"
                >
                  <i className="fas fa-angle-right px-1" />
                </Button>
              )}
            </th>
          ))}
          {canEditPricingStructure && (
            <th key="delete-action" className="fit compact">
              {" "}
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        {_.isEmpty(table.body) && (
          <tr>
            <td>No tiers loaded</td>
          </tr>
        )}
        {_.map(table.body, (row) => (
          <tr key={row.tierIndex}>
            <td key="tierFrom" className="compact" style={{ width: "100px" }}>
              <FormikBootstrap.NumberDropdown
                name={`${name}.tiers.${row.tierIndex}.tierFrom`}
                exclude={table.tierFroms}
                window={15}
                range={[1, null]}
                disabled={row.tierFromColumn.value === 1 || !canEditPricingStructure}
                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
              />
            </td>
            {_.map(row.rateColumns, (v, idx) => (
              <td key={idx} className="compact">
                <FormikBootstrap.NumberInput
                  name={`${name}.tiers.${row.tierIndex}.rates.${v.category}`}
                  readOnly={readOnly}
                  displayScale={100.0}
                />
              </td>
            ))}
            {canEditPricingStructure && (
              <td key="removeTier" className="fit compact">
                <Button
                  key="remove"
                  variant="danger"
                  size="sm"
                  onClick={() => onRemoveTier(row.tierIndex)}
                  disabled={row.tierFromColumn.value === 1}
                >
                  <i className="fas fa-trash" />
                </Button>
              </td>
            )}
          </tr>
        ))}
        {canEditPricingStructure && !_.isEmpty(table.orderedRateCategories) && (
          <tr>
            <td className="compact">{/* TIER_FROM */}</td>
            {_.map(table.orderedRateCategories, (ctg) => (
              <td key={`remove-${ctg}`} className="compact">
                <Button variant="danger" size="sm" onClick={() => onRemoveCategory(ctg)}>
                  <i className="fas fa-trash" />
                </Button>
              </td>
            ))}
            <td className="compact">{/* TIER_ACTION_REMOVE */}</td>
          </tr>
        )}
      </tbody>
    </Table>
  )
}

export default TieredRatesheetTable
